import type {
  KeyIndicatorData,
  KeyIndicatorsData,
  KeyIndicatorType,
} from '@payaca/types/analyticsTypes';
import type { DeclareAsyncAction } from '../types';

export interface AnalyticsState {
  keyIndicatorsData: KeyIndicatorsData | null;
}

export enum AnalyticsActionTypes {
  REQUEST_GET_KEY_INDICATORS_DATA = 'analytics.requestGetKeyIndicatorsData',
}

export interface AnalyticsSagaConfig {
  apiBaseurl: string;
  getAuthHeader: () => string;
}

export type GetKeyIndicatorsData = DeclareAsyncAction<
  AnalyticsActionTypes,
  {
    request: {
      type: AnalyticsActionTypes.REQUEST_GET_KEY_INDICATORS_DATA;
      payload: {
        indicatorTypes: KeyIndicatorType[];
        callback?: (
          keyIndicatorData: KeyIndicatorData<KeyIndicatorType>[]
        ) => void;
        onErrorCallback?: (error: Error) => void;
      };
    };
  }
>;
